export default {
  "content": "<path d=\"M12.361 28.508a.319.319 0 01-.337.419c-1.71-.064-8.709-1.012-8.709-8.74 0-9.6 10.43-8.55 10.534-16.949a.25.25 0 01.286-.236c.046.007.09.026.125.055 1.994 1.685 8.655 7.03 7.165 13.678a.068.068 0 00.01.065.07.07 0 00.06.028 5.687 5.687 0 005.325-3.33.156.156 0 01.286-.036c1.568 3.302 4.094 12.99-4.726 16.958a2.636 2.636 0 01-2.113 0c-2.093-.906-6.16-3.543-4.305-9.954a.099.099 0 00-.076-.118.1.1 0 00-.05.002c-5.32 1.727-4.004 6.685-3.475 8.158z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};